/**
 * Ganzzahlfelder ohne Nachkommastellen — `payment_due_day` (1–28),
 * `notice_period_months` (Spec 03, „Reiter Stammdaten eines Vertrags").
 * Inhaltlich deckungsgleich mit `features/properties/integer.ts`, hier noch
 * einmal eigenständig (`features/*` dürfen einander nicht importieren,
 * `apps/web/CLAUDE.md`). Die eigentliche Wertebereichsprüfung bleibt beim
 * Server; ein ungültiger Wert kommt als Feldfehler zurück, nicht als
 * Client-Validierung.
 */

const INTEGER = /^-?\d+$/

/** `""` → `null` (das Feld ist optional), sonst die Ganzzahl — `null` auch
 * bei allem, was keine reine Ganzzahl ist. */
export function parseIntegerInput(input: string): number | null {
  const trimmed = input.trim()
  if (trimmed === '') return null
  if (!INTEGER.test(trimmed)) return null

  return Number(trimmed)
}

/** `3` → `"3"`, fürs Vorbelegen eines Eingabefelds. */
export function integerToInputValue(value: number): string {
  return String(value)
}
